import HTTP from "../HTTP";
import pgcHelper from "../helpers/paymentGatewayCustomer";

export default {
  async create(payload) {
    try {
      await HTTP.normal.post(
        "/payment-gateway-customers",
        pgcHelper.createPGCRequestBody(payload)
      );
    } catch (error) {
      throw error.response.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/paymentGatewayCustomer.js